import GatewayAccountBillingDetailsService from './services/GatewayAccountBillingDetailsService';
import AccountBillingPayment from './components/AccountBillingPayment';
import AccountPayment from './components/AccountPayment';
import AccountBilling from './components/AccountBilling/AccountBilling';
import 'edge/billing/app';

export default angular.module('edge.gateway.billing.app', ['edge.billing.app'])

    .factory('billing.AccountBillingDetailsService', GatewayAccountBillingDetailsService)
    .component('gwAccountBillingPayment', AccountBillingPayment)
    .component('gwAccountPayment', AccountPayment)
    .directive('gwAccountBilling', AccountBilling);